export default __webpack_public_path__ + "static/media/logo.59c8a144.png";